var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
///<reference types="@guardian/src-foundations/types/themes" />
import { SvgAlertTriangle } from '@guardian/src-icons';
import { inlineError } from './styles';
/**
 * [Storybook](https://guardian.github.io/source/?path=/docs/source-src-user-feedback-inlineerror--demo) •
 * [Design System](https://theguardian.design/2a1e5182b/p/108ed3-user-feedback/b/3803b4) •
 * [GitHub](https://github.com/guardian/source/tree/main/src/core/components/user-feedback) •
 * [NPM](https://www.npmjs.com/package/@guardian/src-user-feedback)
 *
 * Used to inform the user when a validation has failed or user error has occurred. These messages indicate what went wrong and how to fix it.
 *
 * The following themes are supported: `default`, `brand`
 */
export const InlineError = (_a) => {
    var { children, cssOverrides } = _a, props = __rest(_a, ["children", "cssOverrides"]);
    return (_jsxs("span", Object.assign({ css: (theme) => [
            inlineError(theme.userFeedback && theme),
            cssOverrides,
        ] }, props, { children: [_jsx(SvgAlertTriangle, {}, void 0), children] }), void 0));
};
//# sourceMappingURL=InlineError.js.map
